import React from 'react';
import { themed } from '../../ui/theme';

export type BadgeTone = 'neutral' | 'success' | 'danger' | 'warning' | 'info';
export type BadgeSize = 'sm' | 'md';

// Tokens: o par claro/escuro e a cor de cada tom vêm de styles/tokens.css. `info` usa o azul do resto do app.
// minimal: contorno + texto (flat), mas com contraste suficiente para se destacar.
const MINIMAL: Record<BadgeTone, string> = {
  neutral: 'border-line-strong text-fg',
  success: 'border-success text-success-text',
  danger: 'border-danger text-danger-text',
  warning: 'border-warning text-warning-text',
  info: 'border-info text-info-fg',
};

// saas: preenchido (borda + fundo + texto).
const SAAS: Record<BadgeTone, string> = {
  neutral: 'border-line-strong bg-surface-muted text-fg',
  success: 'border-success-line bg-success-soft text-success-fg',
  danger: 'border-danger-line bg-danger-soft text-danger-fg',
  warning: 'border-warning-line bg-warning-soft text-warning-fg',
  info: 'border-info-line bg-info-soft text-info-fg',
};

const SIZES: Record<BadgeSize, string> = {
  sm: 'px-2 py-0.5 text-[0.7rem]',
  md: 'px-2.5 py-1 text-xs',
};

interface Props {
  children: React.ReactNode;
  tone?: BadgeTone;
  size?: BadgeSize;
  className?: string;
}

const StatusBadge: React.FC<Props> = ({ children, tone = 'neutral', size = 'sm', className = '' }) => (
  <span className={`inline-flex items-center rounded-md border font-semibold ${SIZES[size]} ${themed({ minimal: MINIMAL, saas: SAAS })[tone]} ${className}`}>
    {children}
  </span>
);

export default StatusBadge;
